import React, { useEffect, useRef, useState } from "react";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import EventIcon from "@mui/icons-material/Event";

import {
  Box,
  Button,
  Divider,
  Fab,
  Grid,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
// import {
//   getAccountReachageDetails,
//   getAllEmployeeList,
//   getAlleducatio,
// } from "./appoinmentDashboardApi";
// import SmbAccountReachargeCard from "./AppoinmentDashboardCard";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

// import { smbAccountRechargeCustomApiHandler } from "./smbAccountRechargeCustomApiHandler";

import {
  convertDateToCustomFormat,
  getFirstDateOfMonth,
  getStartOfMonth,
} from "../../utils/commonUtils";
// import AppoinmentDashboardCard from "./AppoinmentDashboardCard";
import { DatePicker } from "@mui/x-date-pickers";
import DatePickerComponent from "../../common/curstomDatePicker";
// import FormModal from "./FormModal";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "../payment/popSearch";
import CardPayment from "../payment/cardPayment";
// import FormModalT from "./FormDatatt";
import {
  getAllEmployeeList,
  getAlleducatio,
} from "../employeeInfo/appoinmentDashboardApi";
import FormModalT from "../employeeInfo/FormDatatt";
import { UserForm } from "./UserForm";
import { GetAllUserProfile } from "./companyLoginApiHandler";
import UserSearchModel from "./UserSearchModel";

export default function UserProfileC({ gridSize }) {
  // const [data, setData] = useState();
  const [open, setOpen] = useState(false);

  const [search, setSearchvalue] = useState("");
  const [searchModal, setSearchModal] = useState(false);

  const datePickerRef = useRef();
  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  const [date, setDate] = useState(getStartOfMonth());

  const [SelectedStartDate, setSelectedStartDate] = useState(
    getFirstDateOfMonth()
  );
  const [modalData, setModalData] = useState(null);
  const [value, setValue] = React.useState("Unassigned");
  const [data, setData] = useState();
  const [valuet, setValuet] = React.useState("Assigned");
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const [selectedDate, setSelectedDate] = React.useState(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = React.useState(false);
  const [cardValue, setCardValue] = useState(null);
  const [list, setList] = useState([]);
  // useEffect(() => {
  //   if (search) {
  //     getAlleducatio(
  //       {
  //         // employeeId:search?.id
  //       },
  //       (data) => {
  //         console.log("list  data?.data?.data ", data);

  //         setList(data?.data?.data?.list);
  //       }
  //     );
  //   }
  // }, [search, cardValue]);
  // useEffect(() => {
  //   GetAllUserProfile(
  //     {
  //       page: 1,
  //       pageSize: 1000,
  //       filter: "",
  //       search: "",
  //     },
  //     (data) => {
  //       console.log("list  data?.data?.data ", data);

  //       setList(data?.data?.data?.list);
  //     }
  //   );
  // }, []);
  const fetchUsers = async () => {
    try {
      const res = await GetAllUserProfile({
        page: 1,
        pageSize: 1000,
        filter: "",
        search: "",
      });

      console.log("list data", res?.data);
      setList(res?.data?.data || []);
    } catch (err) {
      console.error("Error fetching user profiles:", err);
    }
  };
  useEffect(() => {
    fetchUsers();
  }, []);

  // useEffect(() => {}, [modalData]);
  // useEffect(() => {
  //   if (open == false) {
  //     // setModalData({});
  //   }
  // }, [open]);
  useEffect(() => {
    if (modalData) {
      setOpen(true);
    }
  }, [modalData]);


  useEffect(() => {
    console.log("list list== ", list);
  }, [list]);

  return (
    <>
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container="true"
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              borderRadius: "5px",
              color: "#01008B",
              textAlign: "left",
              marginBottom: "20px",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            <Typography variant="h6">User Profiles</Typography>
          </Grid>
          <Grid container alignItems="center" spacing={4}>
            <Grid item xs={12}>
              <TextField
                // value={search?.name || ""}
                readOnly
                value={""}
                placeholder="Search"
                size="small"
                fullWidth
                variant="outlined"
                onClick={() => setSearchModal(true)}
                sx={{
                  width: "100%",
                  backgroundColor: "white",
                  borderRadius: "6px",
                  // color: "#555555",
                  "& .MuiOutlinedInput-root": {
                    border: "none",
                    "& fieldset": {
                      border: "none",
                    },
                    "&:hover fieldset": {
                      border: "none",
                    },
                    "&.Mui-focused fieldset": {
                      border: "none",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#555555",
                    opacity: 6,
                    fontWeight: 500,
                    cursor: "pointer",
                  },
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      {search?.name ? (
                        <CloseIcon
                          sx={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSearchvalue("");
                            setCardValue(null);
                            fetchUsers();
                          }}
                        />
                      ) : (
                        <SearchIcon
                          color="primary"
                          sx={{ cursor: "pointer" }}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />

              <UserSearchModel
                searchModal={searchModal}
                setSearchModal={setSearchModal}
                unPaidBill={list}
                setModalData={setModalData}
                // setSearch={setSearchvalue}
                // callSearchApi={(filteredList) => {
                //   setList(filteredList);
                // }}
              />
            </Grid>

            {/* <Grid item xs={3} sx={{ padding: "0px" }}>
              {!gridSize && (
                <Button
                  fullWidth
                  onClick={() => setOpen(true)}
                  sx={{
                    textTransform: "capitalize",
                    width: { xs: "100%", sm: "auto" },
                    whiteSpace: "nowrap",
                    zIndex: "0",
                  }}
                  size="medium"
                  color="primary"
                  variant="contained"
                  aria-label="add"
                >
                  Add Educational Details
                  <AddIcon sx={{ marginLeft: "6px" }} />
                </Button>
              )}
            </Grid> */}
          </Grid>

          <Grid
            container
            sx={{
              p: "10px",
              mt: 2,
              background: "white",
              borderRadius: "12px",
              overflowX: "auto",
            }}
          >
            {/* Header */}
            <Grid item xs={12}>
              <Grid
                container
                sx={{
                  borderBottom: "1.5px solid black",
                  padding: "10px",
                }}
              >
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    User Name
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Mobile no.
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    MPIN
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Role
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  ></Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                height: "60vh",
                overflowY: "auto",
                marginTop: "10px",
                padding: { xs: "10px", sm: "15px" },
              }}
            >
              {list.map((ele, index) => {
                // if (search && search?.name !== ele?.name) return null;
                if (ele?.role === "User") return null;
                return (
                  <Grid
                    container
                    sx={{
                      p: "8px 0",
                      borderBottom: "1px solid #eee",
                      alignItems: "center",
                      backgroundColor: "#E8E8FF",
                      borderRadius: "8px",
                      mb: 1,
                      cursor: "pointer",
                    }}
                  >
                    <Grid item xs={3} pl={{ xs: 2, sm: 3, md: 6, xl: 12 }}>
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontWeight: "500",
                          fontSize: { xs: "10px", sm: "13px", md: "15px" },
                        }}
                      >
                        {ele?.name || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontWeight: "500",
                          fontSize: { xs: "10px", sm: "13px", md: "15px" },
                        }}
                      >
                        {ele?.mobileNumber || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontSize: { xs: "10px", sm: "13px", md: "15px" },
                          fontWeight: "500",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {ele?.mPin || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontWeight: "500",
                          fontSize: { xs: "10px", sm: "13px", md: "15px" },
                        }}
                      >
                        {ele?.role || "-"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        paddingX: 2,
                      }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        // width={{sm:"80%"}}
                        fullWidth
                        sx={{
                          minWidth: { xs: 60, sm: 100 },
                          // maxWidth: "100%",
                          paddingX: 2,
                          fontSize: { xs: "11px", sm: "13px" },
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        onClick={() => {
                          setModalData(ele);
                          setTimeout(() => setOpen(true), 0);
                        }}
                      >
                        Edit
                      </Button>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>

          {/* <Grid container spacing={2}>
            {list.map((ele, index) => {
              if (search != "" && search?.id != ele?.employeeId) {
                return null;
              }
              return (
                <Grid item lg={4}>
                  <CardPayment
                    item={ele}
                    setOpen={(data) => {
                      // if (value == "SalaryComponents") {
                      //   setOpen(data);
                      // }
                      // if (value == "incentrive") {
                      //   setOpent(data);
                      // }
                      // if (value == "Deductions") {
                      //   setopenDeduction(true);
                      // }
                    }}
                    setModalData={(data) => {
                      setModalData(data);
                      setOpen(true);

                      // // setFormda({...formda,id:data.id,});

                      // setFormda({
                      //   ...formda,
                      //   id: data.id,
                      //   employeeId: data?.employeeId,
                      //   componentName: data?.componentName,
                      //   amount: data?.amount,
                      //   percentage: data?.percentage,
                      // });
                      // setFormdat({
                      //   ...formdat,
                      //   id: data.id,
                      //   employeeId: data?.employeeId,
                      //   incentiveName: data?.incentiveName,
                      //   amount: data?.amount,
                      //   percentage: data?.percentage,
                      //   minimumValue: data?.minimumValue,
                      //   maximumValue: data?.maximumValue,
                      // });
                      // setFormdatTDence({
                      //   employeeId: data?.employeeId,
                      //   componentName: data?.componentName,
                      //   amount: data?.amount,
                      //   percentage: data?.percentage,
                      // });
                    }}
                    cardKet={cardKet?.educationalDetail}
                  />
                </Grid>
              );
            })}
          </Grid> */}
          {/* <FormModalT
            open={open}
            setOpen={setOpen}
            getAll={() => {
              // if(search){
              getAlleducatio(
                {
                  // employeeId:search?.id
                },
                (data) => {
                  setList(data?.data?.data?.list);
                }
              );
              // }
            }}
            modalData={modalData}
            setModalData={setModalData}
          /> */}

          <UserForm
            fetchUsers={fetchUsers}
            modalData={modalData}
            setModalData={setModalData}
            open={open}
            setOpen={setOpen}
          />
        </Grid>
      </Box>
    </>
  );
}
